const ADATA_API_BASE = 'https://api.adata.kz/api/company';
// TODO: заменить на реальный токен авторизации AData из настроек окружения
const ADATA_TOKEN_AUTH = 'jGqLaW9Dxoq5VKmIUYYLHGYlAVjosiB';

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

async function fetchJson(url) {
    const res = await fetch(url);
    if (!res.ok) {
        const text = await res.text();
        let message = `Request failed: ${res.status}`;
        try {
            const json = JSON.parse(text);
            if (json.message) message = json.message;
        } catch (_) {
            if (text) message = text;
        }
        throw new Error(message);
    }

    return res.json();
}

async function requestAdataToken(iinBin) {
    const url = `${ADATA_API_BASE}/basic/${ADATA_TOKEN_AUTH}?iinBin=${encodeURIComponent(
        iinBin
    )}`;
    const json = await fetchJson(url);

    if (!json.success || !json.token) {
        throw new Error(json.message || 'Не удалось получить токен AData');
    }

    return json.token;
}

/**
 * Получить данные контрагента из AData по БИН/ИИН.
 * Делает два запроса: получение токена и последующая проверка.
 * @param {string} iinBin
 * @returns {Promise<Object>} - объект data из ответа AData
 */
export default async function getAdataCompanyInfo(iinBin) {
    const trimmed = String(iinBin).trim();
    if (!trimmed) {
        throw new Error('Identifier is required');
    }

    const token = await requestAdataToken(trimmed);

    // Пуллим статус подготовки данных несколько раз
    const maxAttempts = 10;
    const delayMs = 1000;

    for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
        const url = `${ADATA_API_BASE}/info/check/${ADATA_TOKEN_AUTH}?token=${encodeURIComponent(
            token
        )}`;
        const json = await fetchJson(url);

        if (json.success && json.data) {
            return json.data;
        }

        // Если данные ещё готовятся, подождём и попробуем снова
        await sleep(delayMs);
    }

    throw new Error('AData: данные не готовы, попробуйте позже');
}

